import {
  IndividuelleWiederholung,
  TerminWeekdayOccurrence,
  TerminWiederholungsIntervall,
} from '@/domain/termine/shared/types';
import {
  dayNumbers,
  findNextWeekdayInMonth,
} from '@/domain/termine/shared/utils/individuelleWiederholungenHelper';
import dayjs from 'dayjs';

export function addIndividuellTermin(
  current: dayjs.Dayjs,
  individuell: IndividuelleWiederholung,
  start: dayjs.Dayjs,
  addTerminIfInZeitraum: (date: dayjs.Dayjs) => void,
) {
  if (
    individuell &&
    individuell.wiederholungsIntervall === TerminWiederholungsIntervall.WOCHE
  ) {
    dayNumbers(individuell)
      ?.filter((d): d is number => Number.isInteger(d))
      .forEach((dayNumber) => {
        addTerminIfInZeitraum(current.day(dayNumber));
      });
    return;
  }

  if (
    individuell &&
    individuell.wiederholungsIntervall === TerminWiederholungsIntervall.MONAT
  ) {
    addTerminIfInZeitraum(
      findNextWeekdayInMonth(
        current,
        start.day(),
        individuell.weekDayOccurrence ?? TerminWeekdayOccurrence.FIXER_TAG,
      ),
    );
    return;
  }

  if (
    individuell.wiederholungsIntervall === TerminWiederholungsIntervall.JAHR
  ) {
    addTerminIfInZeitraum(
      findNextWeekdayInMonth(
        current.month(start.month()),
        start.day(),
        individuell.weekDayOccurrence ?? TerminWeekdayOccurrence.FIXER_TAG,
      ),
    );
    return;
  }
  addTerminIfInZeitraum(current);
}
